import { TreeAdapter, NodeSource, TreeSource, TreeOptions, TreeAdapterParams } from "@omegagrid/tree";
import rp from "@reporting/rp-app-host";
import { StatementRowAcct, StatementRow, StatementDefinition } from "@reporting/rp-types/definition";

export const DEFAULT_FIN_DROPDOWN_OPTIONS: Partial<TreeOptions> = {
	selectMode: 'single',
	autoClose: true,
	search: true,
}

export class FinDropdownAdapter extends TreeAdapter {
	
	private _rows: NodeSource[];
	private branches = new Map<string, NodeSource[]>();
	public accounting: number;
	
	constructor(
		private type: string,
		private p: string = null,
		private options: Partial<TreeOptions> = null
	) { super() }

	async getTree(params: TreeAdapterParams): Promise<TreeSource> {
		if (this._rows) return this._rows;
		switch (this.type) {
			case 'accounts':
				const accounts = await rp.ms('definition').get<StatementRowAcct[]>('/statementAccounts', { accounting: this.accounting });
				this._rows = accounts.map(account => ({k: account.id_account, v: `${account.id_account || ''} ${account.account || ''}`}));
				break;
			case 'rows': // p = idStatement
				const statementRows = await rp.ms('definition').get<StatementRow[]>('statementRows', { id_statement: this.p, accounting: this.accounting });
				this._rows = statementRows.map(row => ({k: row.id_row.toString(), v: row.row}));
				break;
			case 'years':
				const years = await rp.ms('analytics').get<number[]>('years/all', { accounting: this.accounting });
				this._rows = years.map(year => ({ k: year.toString(), v: year.toString() }));
				break;
			case 'statements':
				const statements = await rp.ms('definition').get<StatementDefinition[]>('statements', { accounting: this.accounting });
				this._rows = statements.map(statement => ({ k: statement.id_statement.toString(), v: statement.statement, props: statement }));
				break;
			case 'statementsTree':
				if (!this.branches.has(params.parentKey)) {
					try {
						const data = await rp.ms('definition').get<TreeSource>('statements', { 
							branchMode: true,
							parent: params.parentKey,
							accounting: this.accounting
						});
						data.forEach(node => {
							node.collapsed = true;
							if (params.parentKey) node.key = `${params.parentKey}:${node.k}`;
						});
						this.branches.set(params.parentKey, data);
					} catch (error) {
						return [
							{k: null, v: error, icon: {icon: "hexagon-exclamation", color: 'red'}}
						];
					}
				}
				return this.branches.get(params.parentKey);
				break;
			default:
				this._rows = [];
		}
		return this._rows;
	}

	getOptions(): Partial<TreeOptions> {
		return this.options || DEFAULT_FIN_DROPDOWN_OPTIONS;
	}
}
